import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { TYPE } from 'theme';
import { RowBetween } from 'components/Row';
import { isMobile } from 'react-device-detect';
import { ArrowIcon } from 'components/Icons';
import SubNavBg from 'assets/images/dashboard/sub-nav.png';
import { default as CButton } from 'components/Button';
import FooterCard from './FooterCard';
import { Card } from './styled';
import MainContent from './main';
import CapsuleManagement from './main/CapsuleManagement';
import { useScrollToAnchor } from 'hooks/useScrollToAnchor';
import { Switch, Route, Redirect, useLocation, Link } from 'react-router-dom';
import { dashboardPath, dashboardOverviewPath, dashboardCapsulePath } from 'constant/route-path';

const Wrapper = styled.div`
    position: relative;
    margin-top: -120px;
    padding-top: 120px;

    .shadow {
        box-shadow: 0px 23px 30px 0px rgba(54, 103, 123, 0.2);
    }
`;

const desktopLayout = css`
    grid-template-columns: 240px 1fr;
    grid-template-rows: auto auto;
    grid-template-areas:
        'nav main'
        'sub main';
`;
const mobileLayout = css`
    grid-template-columns: 100%;
    grid-template-areas:
        'nav'
        'main'
        'sub';
`;

const InnerContent = styled.div`
    padding-bottom: 0;
    display: grid;
    ${desktopLayout}

    ${({ theme }) => theme.mediaWidth.upToSmall`
        ${mobileLayout}
         padding: 40px 0 0 0;
    `};
`;

const Nav = styled.div`
    grid-area: nav;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    background: #1c1c1c;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        width: 100%;
        flex-direction: row;
        padding: 10px;
        gap: 10px;
        color: #000;
        & > div {
            flex: 1;
        }
    `};
`;

const SubNav = styled(Card)`
    grid-area: sub;
    height: 136px;
`;
const SubNavButton = styled(CButton).attrs({
    type: 'secondary',
    size: 'unset',
})`
    color: #000;
    font-size: 12px;
    border-radius: 20px;
    padding: 5px 14px;
    gap: 6px;
`;

const Side = styled.div`
    grid-area: nav;
    position: sticky;
    top: 120px;
    height: fit-content;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        position: static;
        display: contents;
    `};
`;

const Main = styled.div`
    grid-area: main;
`;

function Dashboard() {
    const theme = useTheme();
    const location = useLocation();
    // 首页会跳转到 dashboard 页面并滚动至 Social Profile
    useScrollToAnchor({ block: isMobile ? 'start' : 'center' });

    return (
        <Wrapper>
            <InnerContent style={{ gap: '16px' }}>
                <Side>
                    <Nav>
                        <Link to={dashboardOverviewPath} style={{ textDecoration: 'none' }}>
                            <Card
                                background={
                                    location.pathname === dashboardOverviewPath ? theme.c.linearGradientBg : '#121212'
                                }
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    cursor: 'pointer',
                                    backdropFilter:
                                        location.pathname === dashboardOverviewPath ? 'blur(45px)' : undefined,
                                    boxShadow:
                                        location.pathname === dashboardOverviewPath
                                            ? '0 22.5px 30px 0 rgba(54, 103, 123, 0.1)'
                                            : undefined,
                                    ...(isMobile
                                        ? {
                                              height: '60px',
                                              justifyContent: 'center',
                                          }
                                        : {}),
                                }}
                            >
                                <TYPE.desc fontSize={16}>Overview</TYPE.desc>
                            </Card>
                        </Link>
                        <Link to={dashboardCapsulePath} style={{ textDecoration: 'none' }}>
                            <Card
                                background={
                                    location.pathname === dashboardCapsulePath ? theme.c.linearGradientBg : '#121212'
                                }
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'flex-start',
                                    cursor: 'pointer',
                                    backdropFilter:
                                        location.pathname === dashboardCapsulePath ? 'blur(45px)' : undefined,
                                    boxShadow:
                                        location.pathname === dashboardCapsulePath
                                            ? '0 22.5px 30px 0 rgba(54, 103, 123, 0.1)'
                                            : undefined,
                                    ...(isMobile
                                        ? {
                                              height: '60px',
                                              justifyContent: 'center',
                                          }
                                        : {}),
                                }}
                            >
                                <TYPE.desc fontSize={16}>Capsule Management</TYPE.desc>
                            </Card>
                        </Link>
                    </Nav>
                    {/* <SubNav backgroundImage={SubNavBg} bgIcon="goat">
                        <RowBetween direction="column" align="start" height="100%">
                            <TYPE.main fontSize={14}>
                                One Click to Sign Up our <br /> <strong>GOAT Starship Captains Program</strong>
                            </TYPE.main>
                            <a
                                href="https://forms.gle/Lfgw1WvP4doZ3yrM9"
                                target="_blank"
                                rel="noreferrer"
                                style={{ textDecoration: 'none' }}
                            >
                                <SubNavButton>
                                    Join <ArrowIcon width={8} height={8} />
                                </SubNavButton>
                            </a>
                        </RowBetween>
                    </SubNav> */}
                </Side>
                <Main>
                    <Switch>
                        <Route path={dashboardOverviewPath}>
                            <MainContent />
                        </Route>
                        <Route path={dashboardCapsulePath}>
                            <CapsuleManagement />
                        </Route>
                        <Route path={dashboardPath}>
                            <Redirect to={{ pathname: dashboardOverviewPath, search: location.search }} />
                        </Route>
                    </Switch>
                </Main>
            </InnerContent>
            <FooterCard />
        </Wrapper>
    );
}

export default Dashboard;
